<template>
  <v-container fill-height>
    <v-layout column justify-center>
      <v-flex xs12>
        <h1 class="display-1 my-4 text-xs-center">Blog Posts</h1>
        <auto-complete :posts="posts" class="post--list"></auto-complete>
        <div v-if="posts.length > 0" class="pt-3">
          <post-list :posts="posts"></post-list>
        </div>
        <div v-else class="flex pt-3 xs12 sm12 lg10 offset-lg1 xl8 offset-xl2">
          <v-alert
            :value="true"
            color="info"
            icon=" fas fa-info-circle"
            outline
          >
            Sorry, our posts are currently unavailable
          </v-alert>
        </div>
        <v-alert
          :value="postsError"
          color="error"
          icon="fas fa-exclamation-triangle"
          outline
          class="flex mt-3 xs12 sm12 lg10 offset-lg1 xl8 offset-xl2"
        >
          {{ postsError }}
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import { getPosts } from '../api/posts';
import PostList from '../components/PostList';
import AutoComplete from '../components/AutoComplete';

export default {
  name: 'Blog',
  metaInfo: {
    title: 'Blog',
  },
  components: {
    PostList,
    AutoComplete,
  },
  computed: {
    ...mapGetters({
      postsError: 'postsError',
      posts: 'posts',
    }),
  },
  created() {
    this.getPosts();
  },
  methods: {
    ...mapMutations(['showSnackbar', 'closeSnackbar']),
    getPosts() {
      if (window.sessionStorage.getItem('posts') === null) {
        this.$store.dispatch('posts');
        getPosts()
          .then((res) => {
            this.$store.commit('postsSuccess', res);
            this.postsSuccess();
          })
          .catch((error) => {
            this.postsFailed();
            this.$store.commit('postsFailed', { error });
          });
      } else {
        JSON.parse(window.sessionStorage.getItem('posts'));
      }
    },
    postsSuccess() {
      this.showSnackbar({
        text: 'Post loaded successfully!',
        color: 'success',
        timeout: 5000,
      });
    },
    postsFailed() {
      this.showSnackbar({
        text: 'There were problems getting the posts!',
        color: 'warning',
        timeout: 5000,
      });
    },
  },
};
</script>
